<template>
  <div>
    <template v-if="showBackTop">
      <v-back-top />
    </template>
    <slot />
  </div>
</template>

<script>
import getSymbolFromCurrency from "currency-symbol-map";
import debounce from 'lodash/debounce'
import throttle from 'lodash/throttle'
import { mapState } from "vuex";
import { getUrlParam, previewLinkObserver } from "./lib/util";

export default {
  name: "vApp",
  props: {
    options: {
      type: Object,
      require: true,
    },
    theme: {
      type: Object,
      require: true,
    },
    plug_config: {
      type: [Object, Array],
    },
    // 路由信息
    routeName: {
      type: String,
      default: null
    },
    showBackTop: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showCurrenctSelector: false, // 是否开启货币选择
      preview: null, // 预览模式
      currencyConversionTips: false // 是否显示汇率换算提示
    };
  },
  created() {
    // 计算屏幕宽高
    this.onResize()
  },
  // 挂载之前
  async beforeMount() {
    const { commit } = this.$store;
    const currency = this.options?.woocommerce_currency || null;

    // 货币符号
    const currencySymbol =
      (currency && getSymbolFromCurrency(currency)) || null;
    const { global, name } = this.theme;

     if(global?.show_currency_selector != null){
      this.showCurrenctSelector = global?.show_currency_selector?.hasOwnProperty('show_selector')
      ? global?.show_currency_selector.show_selector || false
      : global?.show_currency_selector || false;
      this.currencySelectorType = global?.show_currency_selector?.hasOwnProperty('currency_selector_type')
        ? global?.show_currency_selector.currency_selector_type
        : 'global';
     this.currencyConversionTips = global?.show_currency_selector?.hasOwnProperty('check_display') && global?.show_currency_selector?.check_display || false
    }else{
      this.showCurrenctSelector = true;
      this.currencySelectorType  = 'global';
    }

    commit("saveBaseState", { theme_name: name });

    commit({
      type: "plugConfig/save",
      payload: { ...this.plug_config },
    });
    // 保存基本配置到全局状态
    commit({
      type: "options/save",
      payload: {
        base: {
          ...this.options,
          currency_symbol: currencySymbol,
        },
        theme: {
          ...this.theme,
          global: {
            ...global,
            show_currency_selector: this.showCurrenctSelector,
            currency_conversion_tips: this.currencyConversionTips,
            //currency_selector_type为空时设置为'global',//top
            currency_selector_type: this.currencySelectorType ? this.currencySelectorType : "global",
          },
        },
        routeName: this.routeName
      },
    });

    // 初始化货币符号
    commit({
      type: "changePriceType",
      payload: {
        currency: localStorage.getItem("pricetype") || currency,
      },
    });

    // 初始化汇率
    commit({
      type: "saveReats",
      payload: {
        rates: {
          [currency]: 1,
        },
        rates_base: currency,
      },
    });
    // 获取汇率
    await this.getRates();
    // 根据ip 获取国家地址信息，和货币符号
    this.getIpInfo();
  },
  mounted() {
    // 预览模式
    const preview = getUrlParam("preview");
    if (preview) {
      this.bePreview(preview);
    }
    // 计算iframe的宽度
    // 为什么用ifram计算屏幕宽度？
    // iframe position是fliex，计算其宽度，不会触发重绘;
    const iframe = document.getElementById('app_iframe');
    if (iframe && iframe.contentWindow) {
      iframe.contentWindow.addEventListener('resize', debounce(this.onResize, 200))
    }
    window.addEventListener('scroll', throttle(this.onScroll(),300));
    if(window.performance.navigation.type == 2) {
      this.pageShowCallBack()
    }
  },
  beforeDestroy() {
    const iframe = document.getElementById('app_iframe');
    if (iframe && iframe.contentWindow) {
      iframe.contentWindow.removeEventListener('resize', debounce(this.onResize, 200))
    }
  },
  methods: {
    pageShowCallBack() {
      let pathname = window.location.pathname
      let isCheckPage = pathname.includes('/checkouts/')
      let params = isCheckPage ? { cart_hash: pathname.split('/')[2] } : {}
      this.$axios
        .get(API.addcart + '?' + Math.random(), { params })
        .then((res) => {
          this.$store.dispatch('change_news_cart', res.data)
          this.bus.$emit('customGetCart', res.data)
          let cart_contents_count = res?.data?.cart_contents_count || 0
          this.$store.dispatch('cartContentsCount', cart_contents_count)
          localStorage.setItem('cartContentsCount', cart_contents_count)
        })
        .catch((err) => {
          this.bus.$emit('customGetCart', false)
        })
      if (isCheckPage) {
        this.$axios.post(API.statis_event, {
          name: 'page.rollback',
          parameters: {
            url: window.location.href,
            referrer: document.referrer,
          },
        })
      }
    },
    bePreview(preview){
      const { commit } = this.$store;
      //处于预览模式下执行
      this.preview = preview;
      commit({
        type: "options/savePreviewMode",
        payload: {
          enable: true,
          id: preview,
        },
      });
      // 监听ifram 传递过来的信息
      window.addEventListener("message", (e) => {
        this.messageListen(e);
      });

      // 开启预览模式下的链接拦截
      previewLinkObserver(preview);
    },
    // 消息监听
    messageListen(message) {
      // 仅在预览模式下生效
      const {
        data: { type, data },
      } = message;

      switch (type) {
        // 模块锚点滚动
        case "scrollTop":
          this.sctoll(data?.id);
          break;
        default:
          console.log(type);
      }
    },
    // 获取基本汇率
    async getRates() {
      // 判断当前是否有开启货币选择
      const checkoutCurrency = this.options?.woocommerce_currency || null;
      const showCurrenctSelector = this.showCurrenctSelector;

      const { dispatch } = this.$store;

      await dispatch({
        type: "getRates",
        payload: {
          checkoutCurrency,
          showCurrenctSelector,
        },
      });
    },
    // 获取ip地址信息
    getIpInfo() {
      const checkoutCurrency = this.options?.woocommerce_currency || null;
      const showCurrenctSelector = this.showCurrenctSelector;
      const checkoutAutoComplete = this.options?.checkout_auto_complete;
      const { dispatch, commit } = this.$store;

      dispatch({
        type: "getIpInfo",
        payload: {
          checkoutCurrency,
          showCurrenctSelector,
          checkoutAutoComplete,
        },
      });
    },

    // 滚动锚点， 即在装修模式下，点击模块，需滚动直到指定位置
    sctoll(id) {
      if (!id) return;

      const dom = this.$(`#${id}`);

      if (dom?.length === 0) return;

      // 计算其他模块高度
      // 需要考虑存在模块是固定在顶部的情况
      let top = dom[0].offsetTop;

      // 公告栏为固定时，要把公告栏计算进去
      if (
        this.header.visibility === "default" &&
        this.header.notice_visibility
      ) {
        // 如果是仅首页展示时
        if (
          !this.header.only_homepage ||
          (this.header.only_homepage && location.pathname === "/")
        ) {
          const noticeDivHeight =
            this.$("#header .section-header-notice")?.[0]?.offsetHeight || 0;
          top -= noticeDivHeight;
        }
      }

      // 如果heaer为悬浮固定
      if (this.header.visibility === "float") {
        const headerDivHeight = this.$("#header")?.[0].offsetHeight || 0;
        top -= headerDivHeight;
      }

      // 滚动到指定位置
      this.$("html, body").animate(
        {
          scrollTop: top - 10,
        },
        500
      );
    },
    onScroll(){
      let pageYOffset = 0;
      return ()=> {
          // true 为 向下滚动
          console.log(pageYOffset,window.pageYOffset);
          let state = pageYOffset < window.pageYOffset ;
          let abs = Math.abs(pageYOffset - window.pageYOffset);
          pageYOffset = window.pageYOffset > 0 ? window.pageYOffset : 0;
          if(abs < 20) return;
          const { commit } = this.$store;
          commit({
            type: 'setScrollMethod',
            payload: {
              method:state?'down':'up',
            }
          })
      }
    },

    onResize(e) {
      const iframe = document.getElementById('app_iframe');

      if (!iframe) return

      const width = iframe?.clientWidth;
      const height = iframe?.clientHeight;

      const { commit } = this.$store;

      commit({
        type: 'setScreenWidth',
        payload: {
          width,
          height
        }
      })
    }
  },
  computed: {
    ...mapState({
      header: ({ options }) => options?.theme?.modules?.header || {},
    }),
  },
};
</script>
